import React from 'react';

export function useDeviceType() {
  const [device, setDevice] = React.useState<'mobile' | 'tablet' | 'desktop'>(
    window.innerWidth <= 768
      ? 'mobile'
      : window.innerWidth <= 1024
      ? 'tablet'
      : 'desktop',
  );

  React.useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 768 && device !== 'mobile') {
        setDevice('mobile');
      } else if (
        window.innerWidth > 768 &&
        window.innerWidth <= 1024 &&
        device !== 'tablet'
      ) {
        setDevice('tablet');
      } else if (window.innerWidth > 1024 && device !== 'desktop') {
        setDevice('desktop');
      }
    }

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [device]);

  return device;
}
